import { createFileRoute, redirect } from '@tanstack/react-router'
import { getBookingQueryOptions } from '@/queries/query'
import { PaymentInfoSearchSchema } from '@/schemas/page'
import { HITPAY_PAYMENT_STATUS, PAYMENT_METHOD_CODE } from '@/utils/constant'

export const Route = createFileRoute('/make-booking/$id/payment/info')({
  validateSearch: PaymentInfoSearchSchema,
  beforeLoad: async ({ context, params }) => {
    const resBooking = await context.queryClient.fetchQuery(
      getBookingQueryOptions(params.id),
    )
    if (
      resBooking.data.booking.payment_method === PAYMENT_METHOD_CODE.HIT_PAY
    ) {
      return redirect({
        replace: true,
        to:
          resBooking.data.booking.payment_response?.status ===
          HITPAY_PAYMENT_STATUS.SUCCEEDED
            ? '/make-booking/$id/payment/success'
            : resBooking.data.booking.payment_response?.status ===
                HITPAY_PAYMENT_STATUS.FAILED
              ? '/make-booking/$id/payment/failed'
              : '/make-booking/$id/payment/process',
        params: {
          id: resBooking.data.booking.id,
        },
      })
    }
    // TODO: Should redirect to process or success
    if (
      resBooking.data.booking.payment_method ===
      PAYMENT_METHOD_CODE.BANK_TRANSFER
    ) {
    }
    // TODO: Should redirect to confirmed
    if (resBooking.data.booking.payment_method === PAYMENT_METHOD_CODE.NET_30) {
    }
  },
})
